export const ExperienceEnum = {
  YesLong: 'yes_long_therapy',
  YesShort: 'yes_some_sessions',
  No: 'no'
}
